<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{ search: string }>()

const emit = defineEmits<{ 'update:search': [value: string] }>()

const { t } = useI18n()
</script>

<template>
  <div class="relative flex w-[22rem] max-w-full items-center">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      class="pointer-events-none absolute left-[var(--space-cell)] text-[color:var(--color-text-muted)]"
      fill="none"
      stroke="currentColor"
      stroke-width="1.7"
    >
      <circle cx="7" cy="7" r="4.5" />
      <path d="M10.5 10.5L14 14" />
    </svg>
    <input
      :value="search"
      type="search"
      :aria-label="t('accounts.searchLabel')"
      :placeholder="t('accounts.searchPlaceholder')"
      class="min-h-[var(--density-control)] w-full rounded-[var(--radius-control)] border border-[color:var(--color-border-control)] bg-[color:var(--color-surface)] py-0 pl-[calc(var(--space-cell)+1.5rem)] pr-[4.5rem] text-[length:var(--text-step-3)] text-[color:var(--color-text)] placeholder:text-[color:var(--color-text-muted)]"
      @input="emit('update:search', ($event.target as HTMLInputElement).value)"
    />
    <kbd
      aria-hidden="true"
      class="pointer-events-none absolute right-[var(--space-inline)] rounded-[var(--radius-control)] border border-[color:var(--color-border)] bg-[color:var(--color-surface-sunken)] px-[var(--space-inline)] font-sans text-[length:var(--text-step-1)] text-[color:var(--color-text-muted)]"
      >⌘K</kbd
    >
  </div>
</template>
